import { Component, OnInit } from '@angular/core';
import { HttpService } from 'src/app/http.service';
import { ThemePalette, ProgressSpinnerMode } from '@angular/material';
import { ThrowStmt } from '@angular/compiler';
import { GlobalService } from '../global.service';
import { RouterModule, Router} from '@angular/router'
import { time } from 'console';
import {formatDate } from '@angular/common';
import { CloseScrollStrategy } from '@angular/cdk/overlay';


@Component({
  selector: 'app-prepare-daily-script',
  templateUrl: './prepare-daily-script.component.html',
  styleUrls: ['./prepare-daily-script.component.scss']
})
export class PrepareDailyScriptComponent implements OnInit {

  today_date: any;
  tomorrow_date: any;
  show_date: any = null;
  // day_list = ['Today', 'Tomorrow']
  selected_day: any = null;
  selected_date: any = null;
  title = null;
  run_log_id: any = null;
  script_list: any = null;
  is_completed = true;
  show: any = null;
  is_disabled: any = false;
  time: any;
  disable_run = false;
  constructor(private httpService: HttpService, private global: GlobalService, private router: Router) {
    this.getCurrentDate();
    this.title = this.global._active_display_name;
    // console.log(this.today_date.toISOString().split('T'))
    // console.log(new Date(this.today_date).toLocaleString("en-US", {timeZone: "Asia/Kolkata"}).split(',')[1]);

    let current_time = String(new Date().getHours()) + ':' + String(new Date().getMinutes()) + ':' + String(new Date().getSeconds());
    console.log(current_time)
    if (current_time >= "12:00:00" && current_time <= "24:00:00") {
      this.selected_day = 'Tomorrow';
    } else {
      console.log("hellow")
      this.selected_day = 'Today';
    }
    console.log(this.selected_day)

  }

  ngOnInit() {
  }

  runClicked() {
    this.disable_run = true;
    let data_dict = {
      'date': ''
    }
    if (this.selected_day == 'Today') {
      console.log(this.today_date)
      data_dict['date'] = this.today_date.split('T')[0];
      this.selected_date = this.today_date.split('T')[0];
      this.show_date = this.today_date;
      console.log(this.selected_date)
    } else {
      data_dict['date'] = this.tomorrow_date.toISOString().split('T')[0];
      this.selected_date = this.tomorrow_date.toISOString().split('T')[0];
      this.show_date = this.tomorrow_date;
      console.log(this.selected_date)
    }
    // this.selected_day = null;
    this.show = null;
    this.httpService.serveCreateDailyRunLog(data_dict).subscribe((data) => {
      console.log(data);
      this.script_list = data['run_scripts'];
      if (data != null) {
        this.run_log_id = data['run_log_id'];
      }
    }, (error) => {
      this.disable_run = false;
      alert("some error occured");
    });
  }

  buttonClicked(script_name, index) {
    this.is_disabled = true
    let data_dict = {
      "date": this.selected_date,
      "script_name": script_name,
      "run_log_id": this.run_log_id
    }
    this.script_list[index]['is_compleated'] = true;
    this.script_list[index]['process_compleated'] = false;
    console.log(data_dict);
    this.httpService.serveDataForDailyDataUploadScript(data_dict).subscribe((data) => {
      console.log(data);
      this.script_list[index]['progress'] = 100;
      this.script_list[index]['is_compleated'] = data;
      this.is_disabled = false;
      if (index != this.script_list.length-1){
        this.script_list[index+1]['is_compleated'] = false;
      }
      else{
        this.is_completed = false
      }
    }, (error) => {
      this.is_disabled = false;
      this.script_list[index]['progress'] = 0;
      alert("some error occured");
    });

  }

  complete_clicked(){
    let data_dict = {
      "run_log_id": this.run_log_id
    }
    this.httpService.serveDailyScriptCompletedStatus(data_dict).subscribe((data) => {
      console.log(data)
      this.is_completed = data["status"];
      alert(data["alert"]);
      this.router.navigate(['/report/milk/acknowledgement/report/per/session'])
    }, (error) => {
      return true;
    });
  }

  progressBarCalled(data, index) {
    data.progress = 0
    setInterval(() => {
      if(data.progress != 100){
        if(index < 3){
          data.progress += 2;
        }else{
          data.progress += 5;
        }
      }
    }, 3000);
  }

  selectClicked(){
    this.selected_date=null;

  }

  async getCurrentDate(){
    this.today_date = await this.httpService.getCurrentDate();
    let todays_date = new Date(this.today_date);
    this.tomorrow_date = new Date(todays_date)
    this.tomorrow_date.setDate(todays_date.getDate() + 1);
    console.log(typeof(this.tomorrow_date));
  }
}
